import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "../security/privateRoute";
import { MenuItem } from "common/components/layout/menu/menuTypes";
import Permissions from "./permissions";
import FirstContainers from "./firstContainerRegistry";
import ContainersPage from "./containers/ContainersPage";
import Users from "./users";
import DispensarySale from "./dispensarySale";
import PGRegistration from "./receptions/components/pgRegistration";
import Printer from "./printer";
import Backups from "./backups";
import Alerts from "./alerts";
import DictumForm from "./dictums/components/DictumForm";
import OperationCertificates from "./certificates/page";
import DispensariesScreen from "./dispensaries/DispensariesScreen";
import OutputEmailConfig from "./configurationOutputEmail";
import HealthInformation from "./healthApplication";
import PermissionNumbers from "./permissionNumbers";
import CorruptedDataVisualizer from "./corruptedDataVisualizer";
import FirstWarehouses from "./firstWarehouseRegistry";
import Warehouses from "./wareHouse";
import EmailSenderConfig from "./emailSenderConfigutarion";
import Subscriptions from "./subscriptions";
import UpsertDistributionPoint from "./distributionPoints/UpsertDistributionPoint";
import MainLayout from "../common/components/layout/main/MainLayout";
import StockControl from "./stockControl/StockControl";
import DistributionPointsScreen from "./distributionPoints/DistributionPointsScreen";
import CheckStatusPage from "./home/CheckStatusPage";
import UploadCFDIs from "./masiveOperations/CFDIs/UploadCFDIs";
import UploadJsonSATReport from "./masiveOperations/SATReport/UploadJsonSATReport";
import ReceptionScreen from "./receptions/ReceptionScreen";
import ComplementsScreen from "./cfdiComplements/ComplementsScreen";
import TraspasosScreen from "./Traspasos/TraspasosScreen";
import HoseBySaleScreen from "./hoseSale/HoseBySaleScreen";
import JsonReportsScreen from "./jsonReport/JsonReportsScreen";
import UnRelatedCFDIsScreen from "./cfdiComplements/UnRelatedCFDIsScreen";
import FirstAppConfigurationWrapper from "routes/firstConfigApplication/FirstAppConfiguration";
import DashboardScreen from "./dashboard/DashboardScreen";
import RegEntradaScreen from "./entryVolumeMeasurer/RegEntradaScreen";
import VolumeMeasurementsScreen from "./volumeMeasurerRegistries/components/VolumeMeasurementsScreen";

interface RoutesProps {
  menu: MenuItem[];
}

const Routes: React.FC<RoutesProps> = ({ menu }) => {
  return (
    <Router basename="/cv">
      <MainLayout menu={menu}>
        <Switch>
          <Route
            path="/receptions/components/pgRegistration/:id/:inputRegister"
            component={PGRegistration}
          />
          <Route
            path="/distributionPoints/:distributionPointId"
            component={UpsertDistributionPoint}
          />
          <Route
            path="/complement/:parentId/:parentType/:distributionPointId"
            component={ComplementsScreen}
          />

          {menu.map((item) => {
            const { secure, path, component: Component, ...rest } = item;

            return secure ? (
              <PrivateRoute exact path={path} component={Component} {...rest} />
            ) : (
              <Route exact path={path} component={Component} {...rest} />
            );
          })}
        </Switch>
      </MainLayout>
    </Router>
  );
};

export {
  Permissions,
  CheckStatusPage,
  FirstContainers,
  ContainersPage,
  Users,
  DispensarySale,
  DispensariesScreen,
  HoseBySaleScreen,
  RegEntradaScreen,
  ReceptionScreen,
  UnRelatedCFDIsScreen,
  PGRegistration,
  StockControl,
  Printer,
  Backups,
  Alerts,
  OperationCertificates,
  OutputEmailConfig,
  HealthInformation,
  PermissionNumbers,
  CorruptedDataVisualizer,
  VolumeMeasurementsScreen,
  FirstWarehouses,
  Warehouses,
  EmailSenderConfig,
  DistributionPointsScreen,
  TraspasosScreen,
  JsonReportsScreen,
  Subscriptions,
  DictumForm,
  UpsertDistributionPoint,
  UploadCFDIs,
  UploadJsonSATReport,
  FirstAppConfigurationWrapper,
  DashboardScreen,
};

export default Routes;
